// extracted by mini-css-extract-plugin
module.exports = {"root":"CalendarMonthTitle_root__W660R"};